import { TargetRatesState } from 'TargetRatesApp/interfaces/state.interface';

export const TARGET_RATES_APP_STATE_SLICE_KEY = 'targetRates';

export const TARGET_RATES_DEFAULT_STATE: TargetRatesState = {
    showRecessions: false,
};
